<template>
	<div class="page page_fans page_adress">
		<van-list v-model="loading" :finished="finished" finished-text="没有更多了" @load="getData">
			<div class="list">
				<div class="item" v-for="(item,index) in dataList" :key="index">
					<div class="item-l">
						<div class="info-val">昵称：{{ item.username }}</div>
						<div class="info-val">扫码时间：{{ item.created_at }}</div>
					</div>
				</div>
			</div>
		</van-list>
	</div>
</template>
<script>
export default {
	data(){
		return{
			token: null,
			id: null,
			page: 1,
			size: 10,
			dataList: [],
			loading: false,
			finished: false,
		}
	},
	created() {
		this.token = this.$store.getters.token;
		this.id = this.$route.query.id;
	},
	methods: {
		/**
		 * @name: 获取扫码记录
		 * @return {*}
		 * @desc: 
		 */		
		getData(){
			let params = {
				token: this.token,
				page: this.page,
				size: this.size,
				id: this.id
			};
			this.$api.agent.agnetQrcodedetail(params).then(res=>{
				if(res.code == 200){
					let list = res.result;
					if(list && list.length){
						if(this.page == 1){
							this.dataList = list;
						}else{
							for(let i in list){
								this.dataList.push(list[i])
							};
						}
						if(list.length < this.size){
							this.finished = true;
						}else{
							this.page++;
							this.loading = false;
						}
					}else{
						this.finished = true;
					}
				}else{
					this.finished = true;
					this.$toast(res.message);
				}
			})
		},
	},
}
</script>